import {useState, useEffect} from "@wordpress/element"
import { useFetch } from "../../../../utilities/useFetch"
import Pagination from '@mui/material/Pagination';
import { LinearProgress} from "@mui/material"
import CardTurismoLex from "../cardTurismoLex/cardTurismoLex"
import CardNoticiasBlog from "../cardNoticiasBlog/cardNoticiasBlog"
import CardCursos from "../cardCursos/cardCursos"
import NoData from "../noData/noData";
import ItemInstitucion from "../itemInstitucion/itemInstitucion"
import AddPagination from "../addPagination/addPagination"
import Diagnostico from "../diagnostico/diagnostico"
import CardComunidadPractica from '../cardComunidadPractica/cardComunidadPractica'
import CardForo from "../cardForo/cardForo";
import getUrlQuery from "../../../../utilities/getUrlQuery"
import './render-data.css'
import { runFunctionListener } from "../../../../utilities/runFunctionListener"

const RenderData = ({cardType, pathFech}) => {

    const getDataType = document.querySelector('.block-list-fetch');
    let cartType = ''
    if(getDataType){
        cartType = getDataType.getAttribute('data-card-type'); 
    }else{
        cartType = cardType 
    }
    
    const {paramsToPath} = getUrlQuery(pathFech)

    const previusURL = new URL(window.location)
    const [blockPath, setblockPath] = useState(pathFech+paramsToPath)
    const {data, loading} = useFetch(blockPath)
    const postData = data?.data

    useEffect(() => {
        const listener = () => runFunctionListener(pathFech, previusURL, blockPath, setblockPath);
        window.addEventListener('click', listener);
        window.addEventListener('keyup', listener);
    }, [blockPath, pathFech, previusURL, setblockPath]);

    const numBase = 9
    const [currentPage, setCurrentPage] = useState(1);
    useEffect(() => {
        setCurrentPage(1);
    }, []);

    const handlePagination = (e, page) => {
        setCurrentPage(page)
    }

    return (
        <>
            {loading === false ? (

                postData?.status !== 404 ? (
                    <div className="block-rd list-notice">
                        
                        {cartType === 'instituciones' ? (
                            <ItemInstitucion data={postData} />
                        ) : null}

                        {postData.map((element, key) => (
                            cartType === 'Noticias' ? (
                                <CardNoticiasBlog data={element} key={key} name={data.name} />
                            ) : cartType === 'cursos' ? (
                                <CardCursos data={element} key={key} />
                            ) : cartType === 'diagnostico' ? (
                                <Diagnostico data={element} key={key} />
                            ) : cartType === 'community' ? (
                                <CardComunidadPractica data={element} key={key} />
                            ) : cartType === 'foro' ? (
                                <CardForo data={element} key={key} />
                            ) : null
                        ))}

                        {cartType === 'turismo-lex' && (
                        <>
                            {postData.slice(numBase*currentPage-numBase, numBase*currentPage).map((element, key)=>(
                                <CardTurismoLex data={element} key={key} />
                            ))}
                           { Math.ceil(postData.length/numBase) > 1 &&
                            <Pagination 
                                count={Math.ceil(postData.length/numBase)} 
                                defaultPage={currentPage} 
                                onChange={(e, page) => handlePagination(e, page)}
                            />}          
                        </>
                        )}

                        {(cartType === 'turismo-lex' && postData.length == 0) && (
                            <NoData />
                        )}

                    </div>
                ) : (
                    <NoData />
                )

            ) : (
                <LinearProgress className="loading-linear" /> 
            )
        }


        {(!loading && data?.pagination && cartType != 'instituciones' && postData?.status != 404)  && 
            <AddPagination data={data.pagination} />
        }
        </>
    );
}

export default RenderData